import CKEditor from '@ckeditor/ckeditor5-react';
import { PwcCKEditors } from '@pwc/pwc-deals-rich-text-editor';
import React, { useEffect, useState } from 'react';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';

import { readOnlyCKEditorConfig } from 'common/components/RichTextEditor/CKEditorConfig';
import { useSyncedInfo } from 'common/components/Autosync/SyncedInfoProvider.tsx';
import { getLibraryItemsFromStore } from 'features/contentLibrary/libraryItemService';

import initializeCKEditor from './initializeCKEditor';
import './ReadOnlyRichTextEditor.scss';

const { ClassicEditor } = PwcCKEditors;

const ReadOnlyRichTextEditor = ({
  projectId,
  richTextData,
  childrenData = [],
}) => {
  const [editor, setEditor] = useState(null);
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;

  const contextStatusInfoItem = useSyncedInfo();
  useEffect(() => {
    if (editor) {
      const { placeholders } = getLibraryItemsFromStore(richTextData);
      editor.enableReadOnlyMode('inProgressMode');
      editor.ui.view.toolbar.element.style.display = 'none';
      initializeCKEditor({
        projectId,
        editor,
        richTextData,
        childrenData: !placeholders.length ? childrenData : placeholders,
        contextStatusInfoItem,
        isPwcUser,
      });
    }
  }, [
    projectId,
    richTextData,
    childrenData,
    editor,
    contextStatusInfoItem,
    isPwcUser,
  ]);

  return (
    <div className="text-input-fieldset fieldset">
      <div data-testid="ckEditor" className="text-input-container basic">
        <CKEditor
          editor={ClassicEditor}
          onInit={setEditor}
          config={readOnlyCKEditorConfig}
        />
      </div>
    </div>
  );
};

export default ReadOnlyRichTextEditor;
